import { Radio as RadioPrimitive } from "@base-ui/react/radio";
import { RadioGroup as RadioGroupPrimitive } from "@base-ui/react/radio-group";
import { cn } from "../lib/cn";

function RadioGroup({ className, ...props }: RadioGroupPrimitive.Props) {
  return <RadioGroupPrimitive data-slot="radio-group" className={className} {...props} />;
}

/**
 * One choice in a radio group. It renders whatever it is given through
 * `render`, so a whole card can be the choice and still move with the arrow keys.
 */
function Radio({ className, ...props }: RadioPrimitive.Root.Props) {
  return <RadioPrimitive.Root data-slot="radio" className={cn(className)} {...props} />;
}

export { Radio, RadioGroup };
